module.exports = __webpack_public_path__ + "static/fantasyfootball-0ae3fae0030d31e0ec73a61776f06c59.jpg";